import React, {useRef, useState} from "react";
import PropTypes from "prop-types";

const Pin = ({ count, brands }) => {
  const pin = useRef(null);
  return (
    <div className="pin" ref={pin}>
      <div
        className="pin__marker"
      >
        <div>{count}</div>
      </div>
    </div>
  );
};
Pin.propTypes = {
  count: PropTypes.number.isRequired
};

export default Pin;
